import { computed, inject, Injectable, signal } from '@angular/core';
import { DocumentSearchService } from './document-search.service';

@Injectable({ providedIn: 'root' })
export class SearchResultNavigator {
  private readonly searchService = inject(DocumentSearchService);

  readonly foundWords = this.searchService.foundWordsByPageId;

  private readonly _pageIds = signal<string[]>([]);

  readonly pingedWord = computed(() => {
    const index = this.searchService.currentFoundWordIndex();
    if (index === undefined) return undefined;
    return this.foundWordsInPageOrder()[index];
  });

  private readonly foundWordsInPageOrder = computed(() => {
    const words = this.foundWords();
    return this._pageIds().flatMap((pageId) => words[pageId] ?? []);
  });

  setPageIds(pageIds: string[]) {
    this._pageIds.set(pageIds);
  }
}
